import { Navigate, Outlet, Route, Routes } from "react-router";

import AuthorizedRoute from "../components/Routes/AuthorizedRoutes";

import SvarUtBrevHistorikk from "../components/Common/Detalj/SvarUtBrevhistorikk";
import IleggelseOrginalbilde from "../components/Common/Ileggelser/Detalj/IleggelseOrginalbilde";
import IleggelseImageEditorPageContainer from "../components/Common/Ileggelser/Detalj/ImageEditorPageContainer";
import MiljogebyrImageEditorPageContainer from "../components/Common/Miljogebyr/Detalj/ImageEditorPageContainer";
import MiljogebyrOrginalbilde from "../components/Common/Miljogebyr/Detalj/MiljogebyrOrginalbilde";
import IleggelseDetaljPage from "../components/Ileggelse/Detalj/IleggelseDetaljPage";
import InnkrevingPage from "../components/Innkreving/InnkrevingPage";
import MiljogebyrDetaljPage from "../components/Miljogebyr/Detalj/MiljogebyrDetaljPage";

import { bypatruljen, juridiskAll } from "../constants/roles";
import sitePaths from "../constants/sitePaths";

const COMMON_ROLES = [
  bypatruljen.saksbehandler,
  bypatruljen.saksbehandleradmin,
  ...juridiskAll,
];

// Shared detalj child routes for ileggelse subsections.
// React Router handles Fragment children transparently.
const ileggelseDetaljChildren = (
  <>
    <Route index element={<IleggelseDetaljPage />} />
    <Route
      path="svar-ut/:svarUtId/historikk"
      element={<SvarUtBrevHistorikk />}
    />
    <Route path="bilder/:bildeId">
      <Route index element={<IleggelseOrginalbilde />} />
      <Route path="rediger" element={<IleggelseImageEditorPageContainer />} />
    </Route>
  </>
);

// Shared detalj child routes for miljogebyr subsections.
const miljogebyrDetaljChildren = (
  <>
    <Route index element={<MiljogebyrDetaljPage />} />
    <Route
      path="svar-ut/:svarUtId/historikk"
      element={<SvarUtBrevHistorikk />}
    />
    <Route path="bilder/:bildeId">
      <Route index element={<MiljogebyrOrginalbilde />} />
      <Route path="rediger" element={<MiljogebyrImageEditorPageContainer />} />
    </Route>
  </>
);

const Innkreving = () => (
  <Routes>
    {/* All innkreving routes share the same roles — guard once */}
    <Route
      element={
        <AuthorizedRoute roles={COMMON_ROLES}>
          <Outlet />
        </AuthorizedRoute>
      }
    >
      {/* ileggelser section: InnkrevingPage handles list/tab sub-pages; detalj routes override */}
      <Route path="ileggelser">
        <Route
          index
          element={
            <Navigate to={sitePaths.innkreving.ileggelser.default} replace />
          }
        />
        <Route path="venter" element={<InnkrevingPage />} />
        <Route path="stoppet" element={<InnkrevingPage />} />
        <Route path="klar" element={<InnkrevingPage />} />
        <Route path="behandles-innkreving" element={<InnkrevingPage />} />
        <Route path="feilet" element={<InnkrevingPage />} />
        <Route path="vellykket" element={<InnkrevingPage />} />
        <Route path="venter/:id">{ileggelseDetaljChildren}</Route>
        <Route path="stoppet/:id">{ileggelseDetaljChildren}</Route>
        <Route path="klar/:id">{ileggelseDetaljChildren}</Route>
        <Route path="behandles-innkreving/:id">{ileggelseDetaljChildren}</Route>
        <Route path="feilet/:id">{ileggelseDetaljChildren}</Route>
        <Route path="vellykket/:id">{ileggelseDetaljChildren}</Route>
      </Route>

      {/* miljogebyr section */}
      <Route path="miljogebyr">
        <Route
          index
          element={
            <Navigate to={sitePaths.innkreving.miljogebyr.default} replace />
          }
        />
        <Route path="venter" element={<InnkrevingPage />} />
        <Route path="stoppet" element={<InnkrevingPage />} />
        <Route path="klar" element={<InnkrevingPage />} />
        <Route path="behandles-innkreving" element={<InnkrevingPage />} />
        <Route path="feilet" element={<InnkrevingPage />} />
        <Route path="vellykket" element={<InnkrevingPage />} />
        <Route path="venter/:id">{miljogebyrDetaljChildren}</Route>
        <Route path="stoppet/:id">{miljogebyrDetaljChildren}</Route>
        <Route path="klar/:id">{miljogebyrDetaljChildren}</Route>
        <Route path="behandles-innkreving/:id">
          {miljogebyrDetaljChildren}
        </Route>
        <Route path="feilet/:id">{miljogebyrDetaljChildren}</Route>
        <Route path="vellykket/:id">{miljogebyrDetaljChildren}</Route>
      </Route>

      <Route
        index
        element={<Navigate to={sitePaths.innkreving.default} replace />}
      />
    </Route>
  </Routes>
);

export default Innkreving;
